'use strict';

var GridToolbarSystemStatusOverbookingController = function GridToolbarSystemStatusOverbookingController($scope, toolbarGridService) {
  $scope.isReinitializeButtonShown = false;
  $scope.isDeleteButtonShown = false;
  $scope.isDuplicateButtonShown = false;
  $scope.selectedRows = [];
  $scope.onRowSelection = function (selectedRows) {
    toolbarGridService.rowSelectionHandler($scope, selectedRows);
  };
  $scope.reInitialize = function () {
    if (toolbarGridService.validateReinitialization($scope.selectedRows)) {
      $scope.$emit('system-status-overbooking:reinitialize', $scope.selectedRows);
    }
  };
  $scope.addRow = function (origin, destination) {
    toolbarGridService.addRow($scope, origin, destination);
  };
  $scope.duplicateRow = function () {
    var propertiesToDuplicate = ['origin', 'destination', 'cabin', 'startDepartureDate', 'endDepartureDate'];
    toolbarGridService.duplicateRow($scope, propertiesToDuplicate);
  };
  $scope.removeRow = function () {
    toolbarGridService.removeRow($scope);
  };
  $scope.$on('reinit-overbooking:force-add-row', function (event, rowsObject) {
    toolbarGridService.addOverBookingRows($scope, rowsObject.rows);
  });
};
GridToolbarSystemStatusOverbookingController.$inject = ['$scope', 'ToolbarGridService'];
module.exports = GridToolbarSystemStatusOverbookingController;